import { UserProfileResponse } from '@shared/services/userProfile/service.types.ts';

export function transformGetUserProfileDTO(inputData: UserProfileResponse | null | undefined) {
  if (!inputData) {
    return null;
  }

  const { id, role, email, invoicingEmail, companyName, status, vatNumber, onboardingState } = inputData;

  return {
    id,
    role,
    companyName,
    status,
    email: email || '-',
    invoicingEmail: invoicingEmail || '-',
    vatNumber: vatNumber || '-',
    onboardingState,
  };
}
